import * as React from 'react'
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom'
import ERoute from '../../ERoute'
import Home from './Home'
import Conversations from './Conversations'
import Help from './Help'
import News from './News'
import TopNavigation from '../../components/TopNavigation'
import Container from '../../components/Messenger/Container'
import Content from '../../components/Messenger/Content'
import BottomNavigation from '../../components/Messenger/BottomNavigation'

type IProps = {
  onNavigate: () => void
} & RouteComponentProps<any>

const BottomTabs = (props: IProps) => {
  const { location } = props

  return (
    <Container>
      <TopNavigation />

      <Content>
        <Switch>
          <Route path={ERoute.PATH_HOME} component={Home} />
          <Route path={ERoute.PATH_CONVERSATIONS} component={Conversations} />
          <Route path={ERoute.PATH_HELP} component={Help} />
          <Route path={ERoute.PATH_NEWS_OVERVIEW} component={News} />
          <Redirect to={ERoute.PATH_HOME} />
        </Switch>
      </Content>
      <BottomNavigation activePath={location.pathname} />
    </Container>
  )
}

export default BottomTabs